<template>

  <div class="hit-container">

    <hit_dashboard v-if="$store.getters.user.username">
      <div class="hit-well">

            {{ $t("message.preview") }}:

            <small class="hit-html-small">
              <a class="hit-html-a hit-text-primary text-url" target="_blank" v-bind:href="get_url()">{{ get_url() }}</a>
            </small>

      </div>

        <div class="hit-form-group" v-if="$store.getters.user.username && survey">
          <colorPalette :vals="save" :callback="function(id, ret){ get_save(id, ret); var r = {}; r[id] = ret; set_page_colors(r); }"/>
        </div>

    </hit_dashboard>

    <div class="hit-form-group" v-if="survey">
      <div class="hit-row">

        <div class="hit-col-md-12" style="padding:0;">
          <div style="background-color: #fff;">
          <div class="banner">
            <uploadImage
            v-if="$store.getters.user.username"
            v-bind:title="$t('message.edit', {name: $t('message.banner')})"
            :settings="{
              image: {dataUrl: save.banner},
              maxWidth: 1000,
              maxHeight: 1000,
              onSave: function(ret){ get_upload('banner', ret); },
              debug: 0,
              accept: 'image/*'
            }"
            />

            <img v-if="!$store.getters.user.username && save.banner" v-bind:src="save.banner" class="hit-img-responsive">
          </div>
          </div>
        </div>

        <div class="hit-col-md-2 logo-container" v-if="$store.getters.user.username || save.logo">

          <div class="hit-form-group">

            <div class="logo">
              <uploadImage
              v-if="$store.getters.user.username"
              v-bind:title="$t('message.edit', {name: $t('message.logo')})"
              :settings="{
                image: {dataUrl: save.logo},
                maxWidth: 250,
                maxHeight: 250,
                onSave: function(ret){ get_upload('logo', ret); },
                debug: 0,
                accept: 'image/*'
              }"
              />

              <div v-if="!$store.getters.user.username && save.logo">
                <img v-bind:src="save.logo" class="hit-img-responsive">
              </div>

            </div>

          </div>

        </div>


        <div class="hit-col-md-3 middle-content">

          <div class="hit-form-group hit-text-center">
            <badgeSlider :survey="survey" :callback="function(badge){ get_save('badge', badge); }" />
          </div>


            <a href="#" v-on:click.prevent="open.vote = !open.vote" class="hit-btn hit-btn-default hit-btn-block hit-text-left" style="text-align: left; text-decoration: underline;" :style="{'color': save.accent_color2, 'background-color': save.accent_color }" ><hit_icon :id='"pen"' /> {{ $t("message.writeAReview") }}</a>




          <div class="hit-clearfix" ></div>
        </div>

        <div class="hit-col-md-7 middle-content">

          <transition name="fade">
            <div class="hit-form-group" v-if="open.vote" :key="'hit_survey'">
                <component  :is="'hit_survey'" :survey="survey" :design="get_design('hit_survey')" />
            </div>
          </transition>



          <div class="hit-form-group hit-text-center">
            <votingsSlider :survey="survey" :callback="function(votings){ get_save('votings', votings); }" />
          </div>

          <textEditor :style="{'color': save.text, 'background-color': save.background_color}" :text="save.text1" :onSave="function(txt){ get_save('text1', txt) }" />

          <textEditor :style="{'color': save.text, 'background-color': save.background_color}" :text="save.text2" :onSave="function(txt){ get_save('text2', txt) }" />



          <textEditor :style="{'color': save.text, 'background-color': save.background_color}" :text="save.text3" :onSave="function(txt){ get_save('text3', txt) }" />


          <textEditor :style="{'color': save.text, 'background-color': save.background_color}" :text="save.text4" :onSave="function(txt){ get_save('text4', txt) }" />


          <div class="hit-form-group" v-if="survey">
            <div class="hit-list-group">
              <div class="hit-list-group-item hit-active" :style="{'background-color': save.accent_color, 'border-color': save.accent_color, 'color': save.accent_color2}">{{ $t("message.contact") }}</div>
              <div class="hit-list-group-item" :style="{'background-color': save.background_color, 'border-color': save.accent_color, 'color': save.text}">
                <textEditor :text="save.contact" :onSave="function(txt){ get_save('contact', txt) }" />

              </div>

            </div>
          </div>

          <div class="hit-form-group" v-if="survey && survey.user_contact.imprint">
            <div class="hit-list-group">
              <a href="#" class="hit-list-group-item hit-active" :style="{'background-color': save.accent_color, 'border-color': save.accent_color, 'color': save.accent_color2}" v-on:click.prevent="open.imprint = !open.imprint">{{ $t("message.imprint") }}</a>
              <transition name="fade">
                <div class="hit-list-group-item" v-bind:key="open.imprint" v-if="open.imprint" v-html="survey.user_contact.imprint" :style="{'background-color': save.background_color, 'border-color': save.accent_color, 'color': save.text}">
                </div>
              </transition>

            </div>
          </div>

          <div class="hit-form-group" v-if="survey && survey.user_contact.privacy">
            <div class="hit-list-group">
              <a href="#" class="hit-list-group-item hit-active" v-on:click.prevent="open.privacy = !open.privacy" :style="{'background-color': save.accent_color, 'border-color': save.accent_color, 'color': save.accent_color2}">{{ $t("message.privacy") }}</a>
              <transition name="fade">
                <div class="hit-list-group-item" v-bind:key="open.privacy" v-if="open.privacy" v-html="survey.user_contact.privacy" :style="{'background-color': save.background_color, 'border-color': save.accent_color, 'color': save.text}">
                </div>
              </transition>

            </div>
          </div>
        </div>



      </div>
    </div>

  </div>

</template>

<script>
import Vue from 'vue'
import hit_votes_old from '@core/components/assets/hit_votes'
import uploadImage from '@core/components/content/landingpage/uploadImage'
import textEditor from '@core/components/content/landingpage/textEditor'
import colorPalette from '@core/components/content/landingpage/colorPalette'
import badgeSlider from '@core/components/content/landingpage/badgeSlider'
import votingsSlider from '@core/components/content/landingpage/votingsSlider'

Vue.component('hit_votes', {

  extends: hit_votes_old,

  methods: {

    get_votes: function () {
      if (typeof this.survey.feedback === 'undefined' || !this.survey.feedback.length) { return false }

      var data = []

      var avg = 0

      for (var i = 0; i < this.survey.feedback.length; i++) {
        data.push([ this.survey.feedback[i].name, ['hit_stars', {stars: this.survey.feedback[i].average, append: true}], this.survey.feedback[i].date ])
        avg += (this.survey.feedback[i].average * 1)
      }

      return [data, (avg / this.survey.feedback.length)]
    }
  }

})

export default{

  components: {uploadImage, textEditor, colorPalette, badgeSlider, votingsSlider},

  data: function () {
    var colors = {
      background_color: '',
      accent_color: '#55a79a',
      accent_color2: '#ffffff',
      text: '#000000',
      background_image: ''
    }

    var data = {

      save: {
        logo: false,
        banner: false,
        text1: '',
        text2: '',
        text3: '',
        text4: '',
        contact: ''

      },

      open: {
        imprint: false,
        privacy: false,
        vote: false
      },

      survey: false,

      components: {

        'hit_survey': 12,
        'hit_votes': 12
      },

      colors: colors

    }

    data.save = Object.assign(data.save, colors)

    return data
  },

  watch: {

    'save.text' (val) { this.get_save('text', val) }
  },

  methods: {

    get_survey () {
      return this.survey
    },

    get_save (version, ret) {
      var data = {
        user: this.survey.user,
        board: this.survey.ID,
        data: {}
      }

      data.data[version] = ret

      this.$hit_post({'url': 'hitclick/landingpage/set', data: data, callback: function () {}})
    },
    get_upload (version, ret) {
      this.save[version] = ret.dataUrl
      this.get_save(version, ret.dataUrl)
    },

    get_url () {
      return this.$get_url().www_url + this.$router.resolve({ name: 'landingpage',
        params: {
          lang: this.$route.params.lang,
          username: this.$store.getters.user.username,
          boardID: this.$route.params.boardID
        }
      }).href
    },

    get_design (comp) {
      if (comp == 'hit_badge' && typeof this.survey.badge.design === 'string') { return this.survey.badge.design }

      if (comp == 'hit_votes'){
        if(typeof this.survey.hit_votes != "undefined" && typeof this.survey.hit_votes.design === 'string')
          { return this.survey.hit_votes.design }
        else
          return "Table";
      }


      return 'Alphonso'
    },

    get_class: function (col, comp) {
      var r = {}
      r[ 'hit-col-md-' + col ] = true

      return r
    },

    get_components: function () {
      return this.components
    },

    set_page_colors: function (r) {
      this.save = Object.assign(this.save, r)

      this.$store.commit('set_page_color', r)

      this.change_survey_colors()
    },

    change_survey_colors: function () {
      var r = {}

      Object.keys(this.colors).forEach(function (key) {
        r[key] = this.save[key]

        switch (key) {
          case 'background_color':
            // this.survey.badge.bg = r[key];
            this.survey.colors.background_color = r[key]
            break
          case 'accent_color':
            this.survey.colors.accent_color = r[key]
            //this.survey.badge.accent = r[key]
            break
          case 'accent_color2':
            //this.survey.badge.pluscolor = r[key]
            //this.survey.badge.accent2 = r[key]
              this.survey.colors.accent_color2 = r[key]
            break
          case 'text':
            //this.survey.badge.text = r[key]
            r.text_color = r[key];
            this.survey.colors.text_color = r[key]
            break
        }
      }.bind(this))


      this.$store.commit('set_page_color', r)
      this.survey.colors = r
    },

    get_data: function () {
      var my_class = this

      this.$hit_post({ url: 'hitclick/landingpage/get',
        data: {username: this.$route.params.username, board: this.$route.params.boardID},
        callback: function (ret) {
          if (ret.data[0]) {
            my_class.survey = ret.data[1]
            my_class.survey.badge.design = 'Maria'
            my_class.$store.commit('set_votes', ret.data[1].feedback)

            my_class.save.contact = ''

            if (my_class.survey.user_contact.company) { my_class.save.contact += '<b>' + my_class.survey.user_contact.company + '</b><br />' }

            my_class.save.contact += my_class.survey.user_contact.first_name + ' ' + my_class.survey.user_contact.last_name
            my_class.save.contact += '<br />'
            my_class.save.contact += my_class.survey.user_contact.adress
            my_class.save.contact += '<br />'
            my_class.save.contact += my_class.survey.user_contact.zip + ' ' + my_class.survey.user_contact.city

            if (typeof ret.data[1].meta === 'object') {
              Object.keys(ret.data[1].meta).forEach(function (v, k) {
                if (Object.values(ret.data[1].meta)[k]) { my_class.save[v] = Object.values(ret.data[1].meta)[k] }
              })

               my_class.change_survey_colors();

          
               if (typeof my_class.save.votings === 'string') {
                 my_class.save.votings = JSON.parse(my_class.save.votings);
                 my_class.survey.votings = my_class.save.votings
               }

              if (typeof my_class.save.badge === 'string') {

                my_class.save.badge = JSON.parse(my_class.save.badge);
                my_class.survey.badge = my_class.save.badge

              }



            }
          }
        }

      })
    }
  },

  mounted: function () {
    this.get_data()
  }
}
</script>

<style scoped>

.text-url{
  word-break: break-word;
}
.middle-content{
  margin-top: 20px;
}
.logo-container{
  margin-top: -70px;
  text-align: center;
}
.logo{
  width: 150px;
  min-height: 80px;
  background-color: white;
  box-sizing: border-box;
  text-align: center;
  padding:5px;
  margin: 0 auto;
  border: 1px solid lightgrey;
}
.logo img{
  width: 100%;
}
.logo div:first-of-type{
  width: 100%;
}

.banner{
  background-color: white;
  max-height: 250px;
  overflow: hidden;
  text-align: center;
  position: relative;
  width: 100%;

}

.banner img{
  margin-top: -20%;
}

</style>
